import { Check, ContentCopy } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { useState } from "react"

export default function CopyToClipboard({ text }: { text: string }) {
  const [isCopied, setCopied] = useState(false)
  async function handleClickCopy() {
    if (!isCopied) {
      try {
        await navigator.clipboard.writeText(text)
        setCopied(true)
        setTimeout(() => {
          setCopied(false)
        }, 3000)
      } catch (err) {
        console.log("Something went wrong when copying to clipboard")
      }
    }
  }
  return (
    <IconButton disabled={isCopied} onClick={handleClickCopy} sx={{ p: 0.5 }}>
      {isCopied ? (
        <Check color="success" fontSize="small" />
      ) : (
        <ContentCopy fontSize="small" />
      )}
    </IconButton>
  )
}
